{
  "passengersSelect": {
    "passengers": {
      "amount": "{n} жолаушы",
      "adults": "Ересектер",
      "adultShort": "{n} ерс",
      "children": "Балалар",
      "childShort": "{n} бала",
      "infants": "Сәбилер",
      "infantShort": "{n} сәби"
    },
    "cabinClass": {
      "economy": "эконом",
      "business": "бизнес-класс",
      "youth": "жастар тарифі"
    }
  }
}
